import {Inject, Injectable} from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import {ApiService} from "../api.service";
import {Headers} from "@angular/http";
import { tokenNotExpired } from 'angular2-jwt';

@Injectable()
export class AuthGuard implements CanActivate {

  private _isLoggedIn: any;
  private _isBrowser: boolean;

  constructor(
    private router: Router,
    @Inject('isBrowser') isBrowser: boolean,
    @Inject("isLoggedIn") isLoggedIn: boolean,
    private apiService: ApiService
  ) {
    this._isBrowser = isBrowser;
    this._isLoggedIn = isLoggedIn;
  }

  canActivate() {
    return new Promise<boolean>((resolve) => {
      if(this._isBrowser === false){
        //it's node so get value from session
        return resolve(this._isLoggedIn);
      }

      if (this._isLoggedIn === true) {
        //it's browser and the token from local storage is valid

        //so let's check the token on the server
        return this.apiService.get('/api/administration/validate', { headers : new Headers({ 'Cache-Control': 'no-cache' }) })
          .subscribe(response => {
            if(response.authenticated){
              resolve(true);
            } else {
              this.router.navigate(['/login']);
              resolve(false);
            }
          });
      }

      //it's browser and the token is not valid
      //so let's reload it from the local storage
      //to check if user had authenticated successfully
      var currentUser = JSON.parse(localStorage.getItem('currentUser'));
      var token = currentUser && currentUser.token;
      let isValid = tokenNotExpired("token",token);

      if(isValid){
        return resolve(true);
      }

      // token not valid, so redirect to login page
      this.router.navigate(['/login']);
      //reject the promise
      resolve(false);
    });

  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/+app/shared/_guards/auth.guard.ts